import { serviceAgreementIntervals } from "./serviceAgreementIntervals";
import { CheckBadgeIcon, PencilIcon } from "@heroicons/react/24/outline";
import { TWclassNames } from "../../../utils/Div";
import { status } from "../../../Utils";
import { useTranslation } from "react-i18next";

export const ServiceAgreementStatusColor = ({ serviceAgreement }) => {};

export const ServiceAgreementStatus = ({ serviceAgreement }) => {
  const { t } = useTranslation();
  const workflow = ["draft", "proposal", "awaiting_signature", "rejected"].includes(serviceAgreement?.status);
  const label = workflow ? `agreementWorkflow.status.${serviceAgreement.status}` : status[serviceAgreement?.status]?.label || "None";

  return (
    <span
      className={TWclassNames(
        status[serviceAgreement?.status]?.class || "bg-slate-100 text-slate-700",
        "block w-full max-w-full truncate rounded-full px-2 py-0.5 text-center text-xs font-semibold leading-5 sm:text-left"
      )}
      title={
        serviceAgreement?.status
          ? `${t(label)}${serviceAgreement?.finished && serviceAgreement?.finished_date ? ` ${serviceAgreement.finished_date}` : ""}`
          : undefined
      }
    >
      {serviceAgreement?.status ? (
        <span className="block truncate">
          {t(label)}
          {serviceAgreement?.finished && serviceAgreement?.finished_date
            ? ` ${serviceAgreement.finished_date}`
            : ""}
        </span>
      ) : (
        <span className="block truncate">{t("common.none")}</span>
      )}
    </span>
  );
};

export const serviceAgreementDaysUntilNextService = ({ agreement }) => {
  const { days_until_next_service } = agreement;

  let object = {
    bgClass: "bg-green-200",
    days: days_until_next_service,
  };

  if (days_until_next_service < 5) {
    object.bgClass = "bg-red-200";
  } else if (days_until_next_service < 15) {
    object.bgClass = "bg-yellow-200";
  } else {
    object.bgClass = "bg-green-200";
  }

  return object;
};

export const ServiceAgreementNextServiceStatus = ({ serviceAgreement }) => {
  const { t } = useTranslation();
  const { days_until_next_service } = serviceAgreement;
  if (serviceAgreement.follow_up_enabled === false) return <span className="text-xs text-slate-500">{t("agreementWorkflow.noFollowUp")}</span>;
  const days =
    days_until_next_service != null ? String(days_until_next_service) : "";

  return (
    <span
      className={TWclassNames(
        "bg-green-100 text-green-800",
        serviceAgreementDaysUntilNextService({ agreement: serviceAgreement })
          .bgClass,
        "inline-block max-w-full truncate rounded-full px-2 text-xs font-semibold leading-5"
      )}
      title={days || undefined}
    >
      {days}
    </span>
  );
};

export const serviceAgreementStatuses = [
  { id: 0, name: "status", value: "draft", label: "Draft" },
  {
    id: 1,
    name: "status",
    value: "active",
    label: "Active",
    icon: CheckBadgeIcon,
  },
  {
    id: 2,
    name: "status",
    value: "canceled",
    label: "Canceled",
    icon: PencilIcon,
  },
  {
    id: 2,
    name: "status",
    value: "deleted",
    label: "Deleted",
    icon: PencilIcon,
  },
];

export { serviceAgreementIntervals };

export const ServiceAgreementIntervalById = (id) => {
  return serviceAgreementIntervals.find((i) => i.id === id);
};

export const ServiceAgreementViewOptions = [
  {
    id: "SERVICE_SOON",
    value: "SERVICE_SOON",
    label: "Service snart (5 dager)",
  },
  {
    id: "ACTIVE",
    value: "ACTIVE",
    label: "Aktive",
  },
];
